import Button from "../base/Button";

const renderIcon = (color) => (
    <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1">
        <title>select</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="LS-Menu"
                transform="translate(-120.000000, -13.000000)"
                stroke={color}
            >
                <g id="select">
                    <g transform="translate(121.250000, 14.000000)">
                        <polygon
                            id="Path"
                            points="0 8.42105263 8.42105263 8.42105263 8.42105263 0 0 0"
                        />
                        <polygon
                            id="Path"
                            points="23.5789474 8.42105263 32 8.42105263 32 0 23.5789474 0"
                        />
                        <polygon
                            id="Path"
                            points="0 32 8.42105263 32 8.42105263 23.5789474 0 23.5789474"
                        />
                        <polygon
                            id="Path"
                            points="23.5789474 32 32 32 32 23.5789474 23.5789474 23.5789474"
                        />
                        <path
                            d="M4.21052632,8.57894737 L4.21052632,23.8301223"
                            id="Path"
                        />
                        <path
                            d="M27.7894737,8.57894737 L27.7894737,23.8301223"
                            id="Path"
                        />
                        <path
                            d="M8.42105263,5.05263158 L23.5789474,5.05263158"
                            id="Path"
                        />
                        <path
                            d="M8.42105263,28.6315789 L23.5789474,28.6315789"
                            id="Path"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for the select tool.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered select button.
 */
const SelectButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default SelectButton;
